rdefine('app/formular/components/frm/SelectboxChoice',['backbone','text!formular/frm.choice.option.html'],function(Backbone,template){
    return Backbone.Ribs.View.extend({
        className:'option-choice',
        bindings:{
            input:{
                value:{data:'model.text',events:'keyup change'}
            }
        },
        events:{
            "click a":"onRemove"
        },
        initialize:function() {
            this.$el.html(Template7.compile(template)());
        },
        onRemove:function() {
            this.model.collection.remove(this.model);
            return false;
        }
    });
});

rdefine('app/formular/components/frm/Selectbox',['backbone','app/formular/components/BaseEditForm','text!formular/frm.choice.html','app/formular/components/frm/SelectboxChoice','app/formular/collections/Choice'],function(Backbone,BaseEditForm,tPlaceholder,SelectboxChoice, ChoiceCollection) {
    return BaseEditForm.extend({
        variants:null,
        bindings:{
            '.options-choices':{
                collection:{
                    view:SelectboxChoice,
                    col:'variants'
                }
            }
        },
        events:{
            "click .add-variant":"onAddVariant"
        },
        init:function() {
            this.$sel=this.$el.find(".card-body");
            this.$sel.html(Template7.compile(tPlaceholder)());
            this.variants=new ChoiceCollection();
            this.updateFromModel();
            this.variants.on("add remove reset recalc",_.bind(this.updateFromCollection,this));

        },
        updateFromModel:function()
        {
            if(this.model.has("variants")) {
                console.log("VARTIANS",this.model.get("variants"));
                var e=[];
                _.each(this.model.get("variants"),function(item){
                    e.push({text:item});
                });
                this.variants.reset(e);
            }
        },
        updateFromCollection:function() {
            var variants=[];
            this.variants.each(function(item){
                variants.push(item.get("text"));
            });
            this.model.set("variants",variants);
        },
        onAddVariant:function() {
            this.variants.add({text:''});
            return false;
        }
    });
});